<mat-card appearance="outlined" class="widget">
    <mat-card-title class="card-title">Kommentarer</mat-card-title>
    <mat-card-content>
        <div *ngFor="let comment of comments" [routerLink]="['/blog', comment.blog_id]" class="blog-comments">
            {{ comment.blog_title }}&nbsp;&nbsp;&nbsp;{{ comment.count }}
        </div>
    </mat-card-content>
</mat-card>
    